import React, { useState } from "react";
import {
    Box,
    Card,
    CardContent,
    Typography,
    TextField,
    Button,
    Snackbar,
    Alert,
} from "@mui/material";
import { useParams, useNavigate } from "react-router-dom";
import { resetPassword } from "../services/ApiService";

const ResetPassword = () => {
    const { uidb64, token } = useParams();
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "error" });
    const navigate = useNavigate();

    const handleReset = async (e) => {
        e.preventDefault();

        if (password !== confirmPassword) {
            setSnackbar({ open: true, message: "Passwords do not match", severity: "error" });
            return;
        }

        try {
            await resetPassword(uidb64, token, {
                password,
            });

            setSnackbar({ open: true, message: "Password reset successful!", severity: "success" });
            setTimeout(() => {
                if (window.opener) {
                    window.close();
                } else {
                    navigate("/login");
                }
            }, 2000);
        } catch (err) {
            setSnackbar({
                open: true,
                message: err.response?.data?.error || "Reset link invalid or expired",
                severity: "error",
            });
        }
    };

    const handleCloseSnackbar = () => setSnackbar({ ...snackbar, open: false });

    return (
        <Box
            sx={{
                minHeight: "100vh",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "linear-gradient(135deg, #0d47a1, #1976d2)",
                padding: 2,
            }}
        >
            <Card sx={{ maxWidth: 420, width: "100%", borderRadius: 3 }}>
                <CardContent sx={{ p: 4 }}>
                    <Typography variant="h5" fontWeight="bold" gutterBottom>
                        Reset Your Password
                    </Typography>
                    <form onSubmit={handleReset}>
                        <TextField
                            label="New Password"
                            type="password"
                            fullWidth
                            required
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            sx={{ mb: 2 }}
                        />
                        <TextField
                            label="Confirm Password"
                            type="password"
                            fullWidth
                            required
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            sx={{ mb: 3 }}
                        />
                        <Button variant="contained" fullWidth type="submit" sx={{ py: 1.2 }}>
                            Reset Password
                        </Button>
                    </form>
                </CardContent>
            </Card>

            {/* Snackbar */}
            <Snackbar
                open={snackbar.open}
                autoHideDuration={4000}
                onClose={handleCloseSnackbar}
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
            >
                <Alert onClose={handleCloseSnackbar} severity={snackbar.severity} sx={{ width: "100%" }}>
                    {snackbar.message}
                </Alert>
            </Snackbar>
        </Box>
    );
};

export default ResetPassword;

